import * as i0 from "@angular/core";
var SettingsService = /** @class */ (function () {
    function SettingsService() {
    }
    SettingsService.ngInjectableDef = i0.defineInjectable({ factory: function SettingsService_Factory() { return new SettingsService(); }, token: SettingsService, providedIn: "root" });
    return SettingsService;
}());
export { SettingsService };
